var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticStyle:{"margin-bottom":"10rem"}},[_c('unauthenticated-header'),_c('router-view'),_c('support-widget-anonymous-dialog'),_c('unauthenticated-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }